import cn from 'classnames'
import type { FC, PropsWithChildren } from 'react'

import css from './ExpandableContent.css'
import { ExpandButton } from './ExpandButton'

type ExpandableContentProps = {
  className?: string
  expanded: boolean
  onExpandClick: VoidFunction
}

export const ExpandableContent: FC<PropsWithChildren<ExpandableContentProps>> = ({
  children,
  expanded,
  onExpandClick,
  className,
}) => {
  return (
    <div
      className={cn(css.container, { [css.fullHeight]: expanded }, className)}
      data-expanded={expanded}>
      <section className={css.body}>{children}</section>
      <ExpandButton expanded={false} onClick={onExpandClick} />
    </div>
  )
}
